"use strict";

exports.__esModule = true;
exports.TimelineRangeSelector = TimelineRangeSelector;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function TimelineRangeSelector(props) {
  var value = props.value,
    setProp = props.setProp;
  var _React$useContext = _react["default"].useContext(_Translator.TranslatorContext),
    translate = _React$useContext.translate;
  return /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
    label: translate("StripeChartFields.dataRange.label", "Data Range"),
    helperText: translate("StripeChartFields.dataRange.helperText", "The data range to show in this stripe chart.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _core.Classes.HTML_SELECT
  }, /*#__PURE__*/_react["default"].createElement("select", {
    value: value || "",
    onChange: function onChange(e) {
      return setProp(e.target.value || undefined);
    }
  }, /*#__PURE__*/_react["default"].createElement("option", {
    value: ""
  }, translate("TimelineTableFields.dataRange.reportingPeriod.label", "Reporting Period")), /*#__PURE__*/_react["default"].createElement("option", {
    value: "SELECTION"
  }, translate("TimelineTableFields.dataRange.selection.label", "Selection")))));
}